import { MembershipSection } from '@/components/membership/MembershipSection';
import { PublicOrgMemberPage } from '@/components/layout/PublicOrgMemberPage';
import { useOrgMemberStore } from '@/store/orgMember';
import { useOrgPaths } from '@/hooks/useOrgPaths';

export default function MemberMembershipPage() {
  const clubSlug = useOrgMemberStore((s) => s.clubSlug);
  const orgProfile = useOrgMemberStore((s) => s.orgProfile);
  const { p } = useOrgPaths();

  if (!clubSlug) {
    return (
      <PublicOrgMemberPage
        title="Membership"
        description="View your membership details, covered people, renewals, and payment history."
      >
        <p className="text-center text-muted-foreground">
          Club membership is not available for this organization.
        </p>
      </PublicOrgMemberPage>
    );
  }

  const joinPath = p('/join') ?? `/club/${clubSlug}/join`;

  return (
    <PublicOrgMemberPage
      title="Membership"
      description="View your membership details, covered people, renewals, and payment history."
    >
      <MembershipSection
        clubSlug={clubSlug}
        clubName={orgProfile?.clubName ?? undefined}
        clubLogoUrl={orgProfile?.organization.logoUrl ?? undefined}
        joinPath={joinPath}
        embedded
      />
    </PublicOrgMemberPage>
  );
}
